export default "__VITE_ASSET__DJl4Kqez__"